const ORDER_ERROR = 'ORDER_ERROR';
const ORDER_SUCCESS = 'ORDER_SUCCESS';
const ORDER_LOADING = 'ORDER_LOADING';

export { ORDER_LOADING, ORDER_ERROR, ORDER_SUCCESS }
